<script>
    import { onMount, afterUpdate } from 'svelte';
    import { current_lang } from '../stores.js';
    import {push} from 'svelte-spa-router'
    
    export let artist;
    export let venue_order;
    export let venue_height;
    export let hour_width;
    export let day_start;

    function hour_to_px(hours, px_width_hour){
        return parseInt(hours) * px_width_hour;
    }

    function minute_to_px(minutes, px_width_hour){
        let px_width_minute = px_width_hour / 60;
        return parseInt(minutes) * px_width_minute;
    }

    function calculate_end_time(start_time, duration){
        let time_parts_start = start_time.split(":");
        let start_hour = parseInt(time_parts_start[0]);
        let start_minutes = parseInt(time_parts_start[1]);

        let time_parts_duration = duration.split(":");
        let duration_hour = parseInt(time_parts_duration[0]);
        let duration_minutes = parseInt(time_parts_duration[1]);

        let end_hour = start_hour + duration_hour;
        let end_minutes = start_minutes + duration_minutes;
        if(end_minutes >= 60){
            end_minutes -= 60;
            end_hour += 1;
        }

        if(end_minutes == 0){
            end_minutes = "00";
        }

        return end_hour + "." + end_minutes;
    }

    function calculate_css_positioning(appearance_info){
        //css positioning

        //TODO: haetaan tämä päivän ensimmäisen esiintyjän perusteella 

        let style_top = 0;
        let style_left = 0;
        let style_width = 0;

        if(venue_order != null){
            if(appearance_info.time != null){
                //top position
                style_top = venue_order * venue_height;

                //left position
                let time_parts_start = appearance_info.time.split(":");
                let start_hour = time_parts_start[0];
                let start_minutes = time_parts_start[1];

                appearance_info.display_time = start_hour + "." + start_minutes;
                if(appearance_info.duration != null){
                    appearance_info.display_time_end = calculate_end_time(appearance_info.time, appearance_info.duration);
                }else{
                    appearance_info.display_time_end = "";
                }
                style_left = hour_to_px((start_hour - day_start), hour_width);
                style_left += minute_to_px(start_minutes, hour_width);

                //width
                style_width = 0;

                //special case for last artists of the day in main stage (if they don't have duration then the duration should last until end of current day)
                if(artist.id == 233 || artist.id == 235 || artist.id == 811){
                    appearance_info.duration = "1:30:00";
                    appearance_info.hide_end_time = true;
                }

                if(appearance_info.duration != null){
                    let time_parts_duration = appearance_info.duration.split(":");
                    let duration_hour = time_parts_duration[0];
                    let duration_minutes = time_parts_duration[1];

                    style_width = hour_to_px(duration_hour, hour_width);
                    style_width += minute_to_px(duration_minutes, hour_width);
                }else{
                    style_width = 120;
                }

                //generate css
                let top_centering = 7.5;
                style_top = "top:" + (style_top + top_centering) + "px;";
                style_left = "left:" + style_left + "px;";
                style_width = "width:" + style_width + "px;";

                appearance_info.css_positioning = style_top + style_left + style_width;
            }
        }

        return appearance_info;
    }

    let extra_class = "";

    onMount(() => {
        artist = calculate_css_positioning(artist);
        if(venue_order == 1){
            extra_class = "color-2";
        }
    });

	afterUpdate(() => {
		artist = calculate_css_positioning(artist);
	});

    //routing to single artist page
    function show_artist(){
        push('/artist/'+artist.id);
    }
</script>
<div class="schedule-box {extra_class}" style="{artist.css_positioning}" on:click={show_artist}>
    <div class="content">
        <h3>{artist.name}</h3>
        <span class="time-info">
            {#if $current_lang == "FI"}
            Klo
            {/if}
            {artist.display_time} - {#if !artist.hide_end_time}{artist.display_time_end}{/if}
        </span>
    </div>
</div>
<style>
    .schedule-box{
        position: absolute;
        background-color: var(--theme-color-3);
        color: #fff;
        height: 75px;
        padding: 5px;
        box-sizing: border-box;
        cursor: pointer;
        border-radius: 2px;
    }

    .schedule-box.color-2{
        background-color: var(--theme-color-4);
    }

    .schedule-box .content{
        position: relative;
        width: 100%;
        height: 100%;
        max-width: 100%;
        display: block;
        white-space: pre-line;
    }

    .schedule-box h3{
        font-family: 'futura-pt', Arial;
        font-weight: 700;
        font-size: 0.9rem;
        line-height: 0.95rem;
        color: #fff;
        margin-bottom: 0;
        margin-top: 0;
        text-transform: none;
        display: block;
    }

    .time-info{
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 0.9rem;
        font-weight: 700;
    }
</style>